import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconChevronDown } from '@carnica/graphics';
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Dropdown = function Dropdown(_ref) {
  var title = _ref.title,
    isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('dropdown'),
    "data-t-id": "components-Dropdown"
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('dropdown__title'),
    color: isOpen ? 'secondary' : 'primary-invert',
    lineHeight: 28,
    onClick: onClick,
    size: 24,
    weight: "regular"
  }, title, /*#__PURE__*/React.createElement(IconChevronDown, {
    className: cn('dropdown__icon', {
      'dropdown__icon--opened': isOpen
    }),
    color: "secondary",
    "data-t-id": "components-Dropdown"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('dropdown-content', {
      'dropdown-content--opened': isOpen
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('dropdown-content-wrapper')
  }, children)));
};